import { useTranslation } from "react-i18next";
import { USER_TABLE } from "./config/user-management-table";
import { toast } from "react-toastify";
import { useState } from "react";
import CreateUserModal from "./CreateUserModal";
import { useApolloClient } from "@apollo/client";
import { CREATE_OR_UPDATE_USER } from "../../services/user.gql";
import { executeGraphQLMutation } from "../../common/executeGraphQLQuery";

const UserManagementTable = ({
  currentTab,
  loading,
  setLoading,
  users,
  getUsersList,
}) => {
  const client = useApolloClient();
  const { t } = useTranslation("common");
  const [showEditModal, setShowEditModal] = useState(0);

  const filteredList = USER_TABLE.filter((column) =>
    column.isForTab.includes(currentTab)
  );

  function handleDeleteClick(user) {
    setLoading(true);
    executeGraphQLMutation(
      CREATE_OR_UPDATE_USER(),
      {
        createOrUpdateUserInput: { id: user.id, status: "0" },
      },
      client
    )
      .then((response) => {
        if (response?.errors?.length) {
          throw response.errors[0];
        } else if (!response?.data?.createOrUpdateUser) {
          throw new Error("Something went wrong!");
        }
        getUsersList();
      })
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  }

  function handleEditClick(user) {
    if (showEditModal) {
      document.body.classList.remove("overflow-hidden");
    } else {
      document.body.classList.add("overflow-hidden");
    }
    setShowEditModal(user?.id || 0);
  }

  return (
    <div>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              {filteredList.map((column) => (
                <th key={column.id}>{column.headerValue(t)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!loading && users.length ? (
              users.map((user) => (
                <tr key={user.id}>
                  {filteredList.map((column) => (
                    <td key={column.id}>
                      {column.dataValue(
                        user,
                        handleDeleteClick,
                        handleEditClick
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : loading ? (
              <tr>
                <td>&nbsp;</td>
              </tr>
            ) : (
              <tr>
                <td
                  colSpan={filteredList.length}
                  style={{ textAlign: "center" }}
                >
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {showEditModal ? (
        <CreateUserModal
          showAddUserModal={showEditModal}
          handleAddUserClick={handleEditClick}
          getUsersList={getUsersList}
          user={users.find((user) => user.id === showEditModal)}
        />
      ) : null}
    </div>
  );
};

export default UserManagementTable;
